/* 
  评卷质量管理
*/
import request from "@/utils/request";

//获取评卷质量管理页面参数
export function getParam() {
  return request({
    url: "/markteacher/markquality/getParam",
    method: "get"
  });
}

//获取评卷质量管理分页列表
export function getMarkQualityMsg(params) {
  return request({
    url: "/markteacher/markquality/getMarkQualityMsg",
    method: "get",
    params
  });
}

//添加评卷质量信息
export function addMarkQualityMsg(data) {
  return request({
    url: "/markteacher/markquality/addMarkQualityMsg",
    method: "post",
    data
  });
}

//删除评卷质量信息
export function deleteMarkQualityMsg(data) {
  return request({
    url: "/markteacher/markquality/deleteMarkQualityMsg",
    method: "post",
    data
  });
}
